export default __webpack_public_path__ + "static/media/bamba2.cbed8bb6.md";